import React, { memo, useMemo, useCallback } from "react";
import { Form } from "react-bootstrap";
import styles from "../../Tax.module.scss";

const BEGINNING_YEAR = 2023;

const YearSelector = memo(({ value, onChange }) => {
  // Memoize years array - only recalculates when component mounts
  const years = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const yearsArray = [];
    for (let year = currentYear; year >= BEGINNING_YEAR; year--) {
      yearsArray.push(year);
    }
    return yearsArray;
  }, []); // Empty deps - years calculation is stable

  const handleChange = useCallback((e) => onChange(e.target.value), [onChange]);

  return (
    <div className={styles.formGroup}>
      <label className={styles.label}>Select Year</label>
      <Form.Control
        as="select"
        value={value}
        onChange={handleChange}
        className={styles.select}
      >
        <option value="">Choose...</option>
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </Form.Control>
    </div>
  );
});

YearSelector.displayName = "YearSelector";

export { YearSelector };
